import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import ButtonComponent from "Components/common/Button";
import powerDialerStore from "Stores/powerDialerStore";
import "./powerDialer.scss";

const StartTasksSplitButton = ({
  startBtnObj = {},
  totalTasks = 0,
  onStartAll = () => {},
  onPowerDial = () => {}
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { callTaskIds = [], callTaskIdsLoading = false } = powerDialerStore;
  const callCount = callTaskIds.length;

  useEffect(() => {
    if (!open) return;
    const close = e =>
      (e.type === "keydown" ? e.key === "Escape" : !ref.current?.contains(e.target)) &&
      setOpen(false);
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", close);
    };
  }, [open]);

  const toggleMenu = () => {
    !open && powerDialerStore.fetchCallTaskIds();
    setOpen(!open);
  };

  const pick = fn => {
    setOpen(false);
    fn();
  };

  return (
    <div className="startTasksSplit" ref={ref}>
      <ButtonComponent {...startBtnObj} />
      <button
        type="button"
        className="startTasksCaret"
        aria-label="More ways to start"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={toggleMenu}
      >
        <i className="material-icons-outlined">expand_more</i>
      </button>
      {open && (
        <div className="startTasksMenu" role="menu">
          <button
            type="button"
            className="startTasksMenuItem"
            role="menuitem"
            onClick={e => pick(() => onStartAll(e))}
          >
            <i className="material-icons-outlined">playlist_add_check</i>
            <span>
              <span className="itemTitle">
                All {totalTasks} task{+totalTasks === 1 ? "" : "s"}
              </span>
              <span className="itemDesc">
                Calls, emails, LinkedIn and custom tasks, in due order
              </span>
            </span>
          </button>
          {callTaskIdsLoading && (
            <div className="startTasksMenuLoader linear-background" />
          )}
          {!callTaskIdsLoading && callCount > 0 && (
            <button
              type="button"
              className="startTasksMenuItem"
              role="menuitem"
              onClick={() => pick(() => onPowerDial(callTaskIds))}
            >
              <i className="material-icons-outlined">phone_forwarded</i>
              <span>
                <span className="itemTitle">
                  Power dial {callCount} call{callCount > 1 ? "s" : ""}
                  <span className="newTag">NEW</span>
                </span>
                <span className="itemDesc">
                  Only the call tasks. The dialer calls them one after another
                  for you
                </span>
              </span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default observer(StartTasksSplitButton);
